import gql from 'graphql-tag';

export const myMatchesButtonAlbumMembershipGroup = gql`
  query myMatchesButtonAlbumMembershipGroup($id: RecordID!) {
    albumMembershipGroup(
      id: $id
      include_matched_photos_only: true
      root_groups_only: true
    ) {
      id
      identities {
        identity {
          id
        }
      }
    }
  }
`;
